export enum DurationEnum {
  OneYear = 12,
  ThreeYears = 36,
  FiveYears  = 60,
  EverGreen = 0
}
